import { render, staticRenderFns } from "./AGUSButtons.vue?vue&type=template&id=6227735f&scoped=true"
import script from "./AGUSButtons.vue?vue&type=script&lang=js"
export * from "./AGUSButtons.vue?vue&type=script&lang=js"
import style0 from "./AGUSButtons.vue?vue&type=style&index=0&id=6227735f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227735f",
  null
  
)

export default component.exports